module.exports = __webpack_public_path__ + "img/ProcessWarning.49752f4d.svg";